var n=function(n){return function(r){return null==n?void 0:n[r]}};export{n as _};
//# sourceMappingURL=_basePropertyOf.js.map
